module.exports = __webpack_public_path__ + "img/V37.f21e3a62.jpg";